export default __webpack_public_path__ + "static/average-time-to-convert-dark-mode-9cc30910427c06074e860c4181d408a3.png";